// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hcf9HfyA0MKgoF0okWVi .infolayer{-webkit-font-smoothing:subpixel-antialiased;-webkit-transform:translateZ(0) scale(1, 1)}`, "",{"version":3,"sources":["webpack://./../@depmap/data-explorer-2/src/components/DataExplorerPage/styles/ScatterPlot.scss"],"names":[],"mappings":"AACE,iCACE,2CAAA,CACA,2CAAA","sourcesContent":[".ScatterPlot :global {\n  .infolayer {\n    -webkit-font-smoothing: subpixel-antialiased;\n    -webkit-transform: translateZ(0) scale(1, 1);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ScatterPlot": `hcf9HfyA0MKgoF0okWVi`
};
export default ___CSS_LOADER_EXPORT___;
